const CANADA_PROVINCE_LIST = [
	{"value":"AB", "text":"Alberta"},
	{"value":"BC", "text":"British Columbia"},
	{"value":"MB", "text":"Manitoba"},
	{"value":"NB", "text":"New Brunswick"},
	{"value":"NL", "text":"Newfoundland and Labrador"},
	{"value":"NS", "text":"Nova Scotia"},
	{"value":"NU", "text":"Nunavut"},
	{"value":"NT", "text":"Northwest Territories"},
	{"value":"ON", "text":"Ontario"},
	{"value":"PE", "text":"Prince Edward Island"},
	{"value":"QC", "text":"Quebec"},
	{"value":"SK", "text":"Saskatchewan"},
	{"value":"YT", "text":"Yukon"}
];
export default CANADA_PROVINCE_LIST;
